import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {MenuService} from '../services/menu.service';
import {Menu} from "../models/menu";

@Injectable({
    providedIn: 'root'
})
export class MenuItemsResolver  {

    constructor(
        private _menuService: MenuService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        return this._menuService.getItemsAPI();
    }
}
